import { render, staticRenderFns } from "./BbeeAccesosDirectosO.vue?vue&type=template&id=02467bbf"
import script from "./BbeeAccesosDirectosO.vue?vue&type=script&lang=js"
export * from "./BbeeAccesosDirectosO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports